<div class="overlay" *ngIf="isLoading">
    <div class="spinner"></div>
    <p class="loading-text">{{message}}</p>
  </div>